import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__overlay" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "popup__title" }, "Connect", -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "Project", -1)
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "Assignee", -1)
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "Type", -1)
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "Add billing label", -1)
const _hoisted_16 = { class: "popup__tools" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "popup" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "popup",
        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("div", { class: "popup__status" }, _toDisplayString(_ctx.status), 513), [
            [_vShow, _ctx.status.length]
          ]),
          _withDirectives(_createElementVNode("a", {
            href: _ctx.url,
            target: "_blank",
            class: "popup__status"
          }, _toDisplayString(_ctx.url), 9, _hoisted_3), [
            [_vShow, _ctx.url.length]
          ]),
          _createElementVNode("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "form-input --dark",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectFilter) = $event))
            }, null, 512), [
              [_vModelText, _ctx.projectFilter]
            ]),
            _hoisted_5,
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, id) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "dropdown__entry",
                  onClick: _withModifiers(($event: any) => (_ctx.setProjectFilter(id, project.name)), ["stop"])
                }, _toDisplayString(project.name), 9, _hoisted_7)), [
                  [_vShow, !_ctx.projectFilter.length || project.name.toLowerCase().includes(_ctx.projectFilter.toLowerCase())]
                ])
              }), 256))
            ], 512), [
              [_vShow, _ctx.projectFilter.length && _ctx.selectedProject === -1]
            ])
          ]),
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select --dark",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAssignee) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: user.name
                }, _toDisplayString(user.fullName), 9, _hoisted_9))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.selectedAssignee]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select --dark",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeLabels, (type) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: `Type::${type}`
                }, _toDisplayString(type), 9, _hoisted_12))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.selectedType]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "form-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addLabel) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.addLabel]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "button",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createTicket && _ctx.createTicket(...args)), ["stop"]))
            }, "Create"),
            _createElementVNode("button", {
              class: "button --outline",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["stop"]))
            }, "Cancel")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}